import Pane from 'components/Common/Pane'
import Group from 'components/utils/Group'
import config from 'constants/config'
import ProductPaletteProvider from 'contexts/ProductPaletteContext'
import { useAppSelector } from 'hooks/reduxHooks'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import Flag from 'LuxKit/Flag'
import LineSyncIcon from 'LuxKit/Icons/line/LineSyncIcon'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import { rem } from 'polished'
import React, { useCallback, useMemo } from 'react'
import { useIntl } from 'react-intl'
import switchRegion from 'lib/geo/switchRegion'
import styled from 'styled-components'

const Footer = styled(Pane)`
  position: sticky;
  bottom: 0;
  z-index: 1;
  padding: ${rem(12)} ${rem(20)};
`

const InlineRow = styled.span`
  display: inline-flex;
  align-items: baseline; /* or center */
  gap: ${rem(6)};
  white-space: nowrap;
`

function NavBarHamburgerMenuLoyaltyFooter() {
  const intl = useIntl()
  const [tier, tierName] = useCurrentLoyaltyTier()
  const account = useAppSelector(state => state.loyalty.account.data)
  const accountNumber = account?.accountNumber
  const region = account?.region
  const loyaltyCurrency = useMemo(() => {
    return config.regions.find(r => r.code === region)?.currencyCode
  }, [region])
  const handleSwitchRegion = useCallback(() => {
    if (!region) return
    switchRegion(region)
  }, [region])

  const memberLabel = intl.formatMessage(
    {
      id: '4jlWOSaZtUKacHXvpmwF',
      defaultMessage: '\u00b7 Member {accountNumber}',
      description: 'Membership number display in hamburger menu loyalty footer',
    },
    { accountNumber },
  )
  const tierStatusLabel = intl.formatMessage(
    {
      id: 'o4Z9rCaU_ZqiEHTtJ0pZ',
      defaultMessage: 'You are currently a {tierName} member.',
      description: 'Current loyalty tier status text in hamburger menu footer',
    },
    { tierName },
  )
  const switchToLabel = loyaltyCurrency ? intl.formatMessage(
    {
      id: 'PukTcJg7FepZB6pD_dSw',
      defaultMessage: 'Switch to {loyaltyCurrency}',
      description: 'Link text to switch region to loyalty account currency in hamburger menu',
    },
    { loyaltyCurrency },
  ) : ''

  return (
    <ProductPaletteProvider palette={`tier-${tier}`}>
      <Footer background={`tier-${tier}-primary`}>
        <Group direction="vertical" horizontalAlign="center" gap={8}>
          <Group direction="horizontal" gap={4}>
            <BodyText variant="medium" weight="bold">{tierName}</BodyText>
            <BodyText variant="medium">{memberLabel}</BodyText>
            {region && <Flag size="S" countryCode={region} />}
          </Group>

          <InlineRow>
            <BodyText as="span" variant="medium">{tierStatusLabel}</BodyText>
            {loyaltyCurrency && <TextLink onClick={handleSwitchRegion}>{switchToLabel} <LineSyncIcon /></TextLink>}
          </InlineRow>
        </Group>
      </Footer>

    </ProductPaletteProvider>
  )
}

export default NavBarHamburgerMenuLoyaltyFooter
